import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SetPublishedConnectionNameParams {
  readonly id: string;
  readonly name: string;
}

export interface SetPublishedConnectionNameResult extends IResult {
}

export class SetPublishedConnectionNameRequest extends Request<SetPublishedConnectionNameParams, SetPublishedConnectionNameResult> {
  constructor(params: SetPublishedConnectionNameParams) {
    super('setPublishedConnectionName', params);
  }
}
